import script from "./SnapshotList.vue?vue&type=script&setup=true&lang=js"
export * from "./SnapshotList.vue?vue&type=script&setup=true&lang=js"

import "./SnapshotList.vue?vue&type=style&index=0&id=0a189ac8&lang=scss&scoped=true"
import "./SnapshotList.vue?vue&type=style&index=1&id=0a189ac8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a189ac8"]])

export default __exports__